import { PROCEED_ORDER_SUCCESS } from '../redux/checkout/checkout.actions';
export default (() => next => action => {
  if (action && action.type === PROCEED_ORDER_SUCCESS) {
    document.cookie = 'partnerstack_partner_key=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  }
  next(action);
});